import * as React from "react";
import { Link } from "react-router-dom";

import logo from "../images/shaq.jpg";

export function HomePage(): JSX.Element {
    return (
        <div className="App">
            <header className="App-header">
                <Link to="error">
                    <img src={logo} className="App-logo" alt="shaq" />
                </Link>
                <h1 className="App-title">
                    i still haven't updated from the react default page lol
                </h1>
            </header>
            <p className="App-intro">KAZAAM, BITCHES</p>
            <Link to="images">
                <div>important images</div>
            </Link>
            <Link to="billwurtz">
                <div>recommended bill wurtz content</div>
            </Link>
            <a href="https://soundcloud.com/zach-halasz">my soundcloud</a>
        </div>
    );
}
